import { useQuery } from "@tanstack/react-query";
import { useLogbookSettings } from "../../../context/LogbookSettingsContext";
import type { Section } from "../models/Section";
import { getSections } from "../repositories/SectionRepository";

type UseSectionsProps = {
	searchText?: string | null;
	enabled?: boolean;
};

export const useSections = ({
	searchText = null,
	enabled = true,
}: UseSectionsProps = {}) => {
	const { section } = useLogbookSettings();
	const schema = section?.schema;

	return useQuery<Section[], Error>({
		queryKey: ["sections", schema, searchText],
		queryFn: ({ signal }) => getSections({ schema, searchText, signal }),
		enabled,
	});
};
